
import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { RoutePermissionGuards } from './modules/gen/setup/routepermissionguards';
import { PaymentSuccessComponent } from './shared/payment-results/payment-success/payment-success.component';
import { PaymentFailedComponent } from './shared/payment-results/payment-failed/payment-failed.component';




// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    // custom dashboard 
    { path: 'custom/dashboard', loadChildren: () => import('app/shared/custom-dashboard/custom-dashboard.module').then(m => m.DSCstmDashboardModule) },
    // Redirect empty path to '/dashboards/project'
    { path: '', redirectTo: '/apps', pathMatch: 'full' },

    // Redirect signed in user to the '/dashboards/project'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboards/project' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
            // {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            // { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule) }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule) },
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'open', loadChildren: () => import('app/apps/open-documents/open-documents/open-documents.module').then(m => m.OpenDocumentsModule) },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard, RoutePermissionGuards],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'example' },
            { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'example' },

            // Dashboards
            {
                path: 'dashboards', children: [
                    { path: 'proj-dashboard', loadChildren: () => import('app/apps/dashboard/dashboard.module').then(m => m.DashboardModule) },
                ]
            },
            // GIS-Map
            { path: 'map', loadChildren: () => import('app/modules/admin/gis-maps/gis-maps.module').then(m => m.GisMapsModule) },
            //setup routes

            // Apps apps/work-management/proposals
            {
                path: 'apps',

                children: [
                    // HINT -- App Routes
                    // { path: '', loadChildren: () => import('app/modules/bus/internal/internal.module').then(m => m.InternalModule), },
                    // { path: 'documents', component: AddDocumentsComponent, pathMatch: 'full' },
                    { path: 'ai-agents', loadChildren: () => import('app/apps/ai-agents/ai-agents.module').then(m => m.AiAgentsModule) },
                   { path: 'p-task-management', loadChildren: () => import('app/apps/p-task-manager/p-task-manager.module').then(m => m.PTaskManagerModule) },
                    { path: 'ulb-rating', loadChildren: () => import('app/apps/ulb-rating/ulb-rating.module').then(m => m.UlbRatingModule) },
                    { path: 'support', loadChildren: () => import('app/modules/gen/support/support.module').then(m => m.SupportModule) },
                    { path: 'css', loadChildren: () => import('app/apps/css/css-module').then(m => m.CSSModule) },
                    { path: 'user', loadChildren: () => import('app/modules/gen/setup/usercreation/usercreation.module').then(m => m.UsercreationModule) },
                    { path: 'benficiary', loadChildren: () => import('app/apps/ben-loan-management/benificary/benificary.module').then(m => m.BenficiaryModule) },
                    { path: 'dashboards', loadChildren: () => import('app/apps/ben-loan-management/dashboards/dashboards.module').then(m => m.DashboardsModule) },

                    { path: 'supportadmin', loadChildren: () => import('app/modules/gen/support-admin/support-admin.module').then(m => m.SupportAdminModule) },
                    { path: 'reports', loadChildren: () => import('app/modules/gen/reports/reports.module').then(m => m.ReportsModule) },
                    { path: 'portal-management', loadChildren: () => import('app/apps/site-builder/site-builder.module').then(m => m.SiteBuilderModule) },
                    { path: 'files', loadChildren: () => import('app/apps/file-manager/file-manager.module').then(m => m.FileManagerModule) },
                    { path: 'meeting', loadChildren: () => import('app/apps/Meeting management/meeting-management.routing') },
                    // { path: 'appstore', loadChildren: () => import('app/modules/gen/appstore/appstore.module').then(m => m.AppStoreModule) },

                    { path: 'task-management', loadChildren: () => import('app/apps/task-management/task-management.module').then(m => m.TaskManagementModule) },
                    // { path: 'example-center', loadChildren: ()  => import('app/apps/example-center/example-center.module').then(m => m.ExampleCenterModule) },
                    { path: 'develop', loadChildren: ()         => import('app/apps/app-development/app.development.module').then(m => m.AppDevelopmentModule) },
                    { path: 'page-list', loadChildren: () => import('app/apps/core/page-list/page-list.routes') },
                    { path: 'gen-master', loadChildren: () => import('app/apps/core/gen-m/gen-m.routes') },
                    { path: 'sub-nav/:mnu_itm_id', loadChildren: () => import('app/apps/app-sub-nav-module/app-sub-nav.module').then(m => m.AppSubNavModule) },
                    { path: 'client-onboarding', loadChildren: () => import('app/apps/client-onboarding/client_onboard.module').then(m => m.ClientOnBoardModule) },
                    { path: 'bccfc-emi', loadChildren: () => import('app/apps/css/emic/emic.module').then(m => m.EmicModule) },
                    { path: 'vendor', loadChildren: () => import('app/apps/works-monitoring/modules/contractor-module/contractor.module').then(m => m.ContractorsModule) },
                    { path: 'loan-ben', loadChildren: () => import('app/apps/ben-loan-management/ben.loan.module').then(m => m.BenLoanModule) },
                    { path: 'animal-husbendry', loadChildren: () => import('app/apps/animal-husbendry/animal-husbendry.module').then(m => m.AnimalHusbendryModule) },
                    { path: 'tracking', loadChildren: () => import('app/apps/file-tracking/file-tracking.module').then(m => m.FiletrackingModule) },
                    // { path: 'social-media', loadChildren: () => import('app/apps/social-media/social-media.module').then(m => m.SocialMediaModule) },
                    { path: 'detection', loadChildren: () => import('app/apps/rtgs/rtgs.module').then(m => m.RtgsModule) },
                    { path: 'grievance-management', loadChildren: () => import('app/apps/grievance-management/grievance-management.module').then(m => m.GrievanceManagementModule) },




                ]
            },


            { path: 'profile', loadChildren: () => import('app/modules/gen/profile/profile.module').then(m => m.ProfileModule) },
            { path: 'setup', loadChildren: () => import('app/modules/gen/setup/setup.module').then(m => m.SetupModule) },

            // Pages
            {
                path: 'pages', children: [

                    { path: 'cust-page', loadChildren: () => import('app/modules/gen/pages/cust-page/cust-page.module').then(m => m.CustPageModule) },

                    // Activities
                    { path: 'activities', loadChildren: () => import('app/modules/gen/pages/activities/activities.module').then(m => m.ActivitiesModule) },

                    // Authentication
                    { path: 'authentication', loadChildren: () => import('app/modules/gen/pages/authentication/authentication.module').then(m => m.AuthenticationModule) },

                    // Coming soon
                    { path: 'coming-soon', loadChildren: () => import('app/modules/gen/pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule) },

                    // Error
                    {
                        path: 'error', children: [
                            { path: '404', loadChildren: () => import('app/modules/gen/pages/error/error-404/error-404.module').then(m => m.Error404Module) },
                            { path: '500', loadChildren: () => import('app/modules/gen/pages/error/error-500/error-500.module').then(m => m.Error500Module) }
                        ]
                    },


                    // Maintenance
                    { path: 'maintenance', loadChildren: () => import('app/modules/gen/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule) },

                    // Pricing
                    {
                        path: 'pricing', children: [
                            { path: 'modern', loadChildren: () => import('app/modules/gen/pages/pricing/modern/modern.module').then(m => m.PricingModernModule) },
                            { path: 'simple', loadChildren: () => import('app/modules/gen/pages/pricing/simple/simple.module').then(m => m.PricingSimpleModule) },
                            { path: 'single', loadChildren: () => import('app/modules/gen/pages/pricing/single/single.module').then(m => m.PricingSingleModule) },
                            { path: 'table', loadChildren: () => import('app/modules/gen/pages/pricing/table/table.module').then(m => m.PricingTableModule) }
                        ]
                    },





                    // Profile
                    { path: 'profile', loadChildren: () => import('app/modules/gen/pages/profile/profile.module').then(m => m.ProfileModule) },

                    // Settings
                    { path: 'settings', loadChildren: () => import('app/modules/gen/pages/settings/settings.module').then(m => m.SettingsModule) },
                ]
            },

            {
                path: 'apps', children: [
                    // { path: 'registers', loadChildren: () => import('app/modules/gen/registers/registers.module').then(m => m.RegistersModule) },
                ]

            },
            {
                path: 'payment', children: [
                    { path: 'status/:status/:orderId', component: PaymentSuccessComponent, pathMatch: 'full' },
                    // { path: 'failed/:orderId', component: PaymentFailedComponent, pathMatch: 'full' }

                ]
            },

            // Help Center
            {
                path: 'help', children: [

                    // Changelog
                    { path: 'changelog', loadChildren: () => import('app/modules/gen/help-center/changelog/changelog.module').then(m => m.ChangelogModule) },


                ]
            },
            { path: 'entity', loadChildren: () => import('app/shared/entity/entity.module').then(m => m.EntityModule) },
            { path: 'support', loadChildren: () => import('app/modules/help-docs/help-docs.module').then(m => m.HelpDocsModule) },

            { path: 'changelog', loadChildren: () => import('app/modules/changelog/changelog.module').then(m => m.ChangelogModule) },


            // 404 & Catch all
            { path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/gen/pages/error/error-404/error-404.module').then(m => m.Error404Module) },

            { path: 'access-denied', pathMatch: 'full', loadChildren: () => import('app/modules/gen/pages/access-denied/access-denied.module').then(m => m.AccessDeniedModule) },
            { path: '**', redirectTo: '404-not-found', },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule) },
        ]
    },

];
